module.exports = __webpack_public_path__ + "static/img/fish33.366ccfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish33.png
// module id = 9LQ1
// module chunks = 0